// extracted by mini-css-extract-plugin
export default {"menuCardContainer":"TablePricesCard_menuCardContainer__FaUt0","menuCard":"TablePricesCard_menuCard__d0W-U"};